import { render, staticRenderFns } from "./KaraokeRoom.vue?vue&type=template&id=0a288f3d&scoped=true&"
import script from "./KaraokeRoom.vue?vue&type=script&lang=ts&"
export * from "./KaraokeRoom.vue?vue&type=script&lang=ts&"
import style0 from "./KaraokeRoom.vue?vue&type=style&index=0&id=0a288f3d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a288f3d",
  null
  
)

export default component.exports